/* RVRN VIP Hero & Tiers — tier tab switching */
(function () {
  'use strict';

  document.querySelectorAll('[data-section-type="rvrn-vip-hero-tiers"]').forEach(function (section) {
    var grid = section.querySelector('[data-tier-grid]');
    var mobileTabs = section.querySelector('[data-mobile-tabs]');
    if (!grid) return;

    var defaultActive = section.getAttribute('data-default-active') || 'VIP';

    function selectTier(name) {
      // Highlight active card
      grid.querySelectorAll('[data-tier-card]').forEach(function (card) {
        card.classList.toggle('is-active', card.getAttribute('data-tier-card') === name);
      });
      // Sync mobile tabs
      if (mobileTabs) {
        mobileTabs.querySelectorAll('[data-tier-tab]').forEach(function (btn) {
          var active = btn.getAttribute('data-tier-tab') === name;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
    }

    // Card buttons
    grid.querySelectorAll('[data-tier-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectTier(btn.getAttribute('data-tier-select'));
      });
    });

    // Mobile tabs
    if (mobileTabs) {
      mobileTabs.querySelectorAll('[data-tier-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectTier(btn.getAttribute('data-tier-tab'));
        });
      });
    }

    // Init
    selectTier(defaultActive);
  });
})();
